module.exports = __webpack_public_path__ + "img/hzxy_qr.be3a7263.png";